{
  "name": "55edo (Telemann 1767, abbbb-g####)",
  "description": "55-tone equal tempered scale consisting of 55 sonically equal divisions per octave. Similar to 1/6-Pythagorean Comma meantone. Step-size is 21.8 cents.",
  "scale": [
    "1\\55",
    "2\\55",
    "3\\55",
    "4\\55",
    "5\\55",
    "6\\55",
    "7\\55",
    "8\\55",
    "9\\55",
    "10\\55",
    "11\\55",
    "12\\55",
    "13\\55",
    "14\\55",
    "15\\55",
    "16\\55",
    "17\\55",
    "18\\55",
    "19\\55",
    "20\\55",
    "21\\55",
    "22\\55",
    "23\\55",
    "24\\55",
    "25\\55",
    "26\\55",
    "27\\55",
    "28\\55",
    "29\\55",
    "30\\55",
    "31\\55",
    "32\\55",
    "33\\55",
    "34\\55",
    "35\\55",
    "36\\55",
    "37\\55",
    "38\\55",
    "39\\55",
    "40\\55",
    "41\\55",
    "42\\55",
    "43\\55",
    "44\\55",
    "45\\55",
    "46\\55",
    "47\\55",
    "48\\55",
    "49\\55",
    "50\\55",
    "51\\55",
    "52\\55",
    "53\\55",
    "54\\55",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "55edo",
  "built_in_group": "Equal Divisions",
  "key_labels": "note_names",
  "note_names": [
    "c",
    "♭♭d",
    "♭♭♭♭e",
    "♯♯b",
    "♯c",
    "♭d",
    "♭♭♭e",
    "♯♯♯b",
    "♯♯c",
    "d",
    "♭♭e",
    "♭♭♭f",
    "♯♯♯c",
    "♯d",
    "♭e",
    "♭♭f",
    "♯♯♯♯c",
    "♯♯d",
    "e",
    "♭f",
    "♭♭♭g",
    "♯♯♯d",
    "♯e",
    "f",
    "♭♭g",
    "♭♭♭♭a",
    "♯♯e",
    "♯f",
    "♭g",
    "♭♭♭a",
    "♯♯♯e",
    "♯♯f",
    "g",
    "♭♭a",
    "♭♭♭♭b",
    "♯♯♯f",
    "♯g",
    "♭a",
    "♭♭♭b",
    "♯♯♯♯f",
    "♯♯g",
    "a",
    "♭♭b",
    "♭♭♭c",
    "♯♯♯g",
    "♯a",
    "♭b",
    "♭♭c",
    "♯♯♯♯g",
    "♯♯a",
    "b",
    "♭c",
    "♭♭♭d",
    "♯♯♯a",
    "♯b"
  ],
  "note_colors": [
    "#ff9d9d",
    "#ffe5e5",
    "#e4fbe6",
    "#fffae5",
    "#dee2da",
    "#d0d0d7",
    "#dce1d0",
    "#f8ffeb",
    "#fffae5",
    "#ffffff",
    "#ffe5e5",
    "#dce1d0",
    "#f8ffeb",
    "#dee2da",
    "#d0d0d7",
    "#ffe5e5",
    "#cee3e2",
    "#fffae5",
    "#ffffff",
    "#d0d0d7",
    "#dce1d0",
    "#f8ffeb",
    "#dee2da",
    "#ffffff",
    "#ffe5e5",
    "#e4fbe6",
    "#fffae5",
    "#dee2da",
    "#d0d0d7",
    "#dce1d0",
    "#f8ffeb",
    "#fffae5",
    "#ffffff",
    "#ffe5e5",
    "#e4fbe6",
    "#f8ffeb",
    "#dee2da",
    "#d0d0d7",
    "#dce1d0",
    "#cee3e2",
    "#fffae5",
    "#ffffff",
    "#ffe5e5",
    "#dce1d0",
    "#f8ffeb",
    "#dee2da",
    "#d0d0d7",
    "#ffe5e5",
    "#cee3e2",
    "#fffae5",
    "#ffffff",
    "#d0d0d7",
    "#dce1d0",
    "#f8ffeb",
    "#dee2da"
  ],
  "equivSteps": 55,
  "fundamental": 440,
  "reference_degree": 41,
  "center_degree": 0,
  "rSteps": 9,
  "drSteps": 5,
  "hexSize": 42,
  "rotation": -16.102113751
}
